<section class="discovery-panel" [class.discovery-panel--has-selection]="selectedSuggestions?.length > 0">
  @if (!isFromNetworkSetup || (isFromNetworkSetup && mySuggestions.length > 0)) {
    <div
      class="discovery-panel__content"
      [class.discovery-panel__content--setup]="isFromNetworkSetup && !hideHeaderAndControls"
      [class.discovery-panel__content--setup-compact]="isFromNetworkSetup && hideHeaderAndControls"
      [class.discovery-panel__content--with-offset]="switchFromUser"
    >
      <section class="discovery-panel__section">
        @if (!isFromNetworkSetup) {
          <p class="discovery-panel__description">Description</p>
        }

        @if (!hideHeaderAndControls) {
          <div class="search-field">
            <div class="search-field__inner">
              <span><img src="../../../../../../assets/images/blue-search-icon.svg" alt="" /></span>
              <input
                class="search-field__input"
                [(ngModel)]="searchtext"
                type="text"
                placeholder="Search Suggestions"
                autocomplete="off"
                #searchTemplatesInput
              />
              @if (searchtext) {
                <span class="search-field__clear material-icons" (click)="clearSearchAction()">clear</span>
              }
            </div>
          </div>
        }

        <h2 class="discovery-panel__heading">
          Suggestions
          <span class="discovery-panel__count">({{ getFilteredSuggestionsCount() }})</span>
        </h2>

        @if (!hideHeaderAndControls) {
          <div class="suggestions-table-header">
            <div class="suggestions-table-header__row">
              <div class="suggestions-table-header__check">
                <app-shared-checkbox
                 
                  [checked]="selectAll"
                  [(ngModel)]="selectAll"
                  (change)="onSelectAllChange($event)"></app-shared-checkbox>
              </div>
              <div class="suggestions-table-header__avatar-spacer"></div>
              <div class="suggestions-table-header__sort" (click)="toggleSort()">
                <span>Name</span>
                <span class="suggestions-table-header__sort-icon material-icons">
                  {{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                </span>
              </div>
            </div>
          </div>
        }

        @if (getFilteredSuggestions().length > 0) {
          @for (suggestion of getFilteredSuggestions(); track suggestion) {
            <div class="suggestion-row">
              @if (!hideHeaderAndControls) {
                <div class="suggestion-row__check">
                  <app-shared-checkbox
                   
                    [checked]="suggestion.selected"
                    [(ngModel)]="suggestion.selected"
                    (change)="onSuggestionSelectChange(suggestion, $event)"></app-shared-checkbox>
                </div>
              }

              <div class="suggestion-row__avatar">
                <app-user-avatar size="36" [name]="suggestion"></app-user-avatar>
              </div>

              <div
                class="suggestion-row__name-col"
                [class.suggestion-row__name-col--setup]="isFromNetworkSetup"
                [class.suggestion-row__name-col--default]="!isFromNetworkSetup"
              >
                <h3 class="suggestion-row__name">{{ suggestion.name | truncateStrPipe : 23 }}</h3>
              </div>

              <div class="suggestion-row__actions-col">
                <div
                  class="suggestion-row__mutual-col"
                  [class.suggestion-row__mutual-col--setup]="isFromNetworkSetup"
                  [class.suggestion-row__mutual-col--default]="!isFromNetworkSetup"
                >
                  <span class="suggestion-row__mutual" (click)="mutualConnection(suggestion)">
                    {{ getMutualConnectionsCount(suggestion) }} Mutual Connections
                  </span>
                </div>

                <button
                  type="button"
                  class="btn primary small"
                  [id]="'add_' + suggestion.name"
                  (click)="acceptRequest(suggestion)"
                >
                  Add
                </button>

                <app-shared-action-menu [items]="suggestionMenuItems(suggestion)" />
              </div>
            </div>
          }
        } @else if (searchtext) {
          <div class="search-empty">
            <div class="search-empty__icon-wrap">
              <img src="assets/images/no-matchin-result.svg" alt="" />
            </div>
            <div>
              <h3 class="search-empty__title">No matching results to show</h3>
              <p class="search-empty__hint">Try different search terms</p>
            </div>
          </div>
        } @else {
          <div class="suggestion-empty">
            <p class="suggestion-empty__text">No <span class="suggestion-empty__accent">suggestions</span> to show</p>
          </div>
        }
      </section>
    </div>
  }

  @if (isFromNetworkSetup && mySuggestions.length === 0) {
    <div class="zero-state-card">
      <img class="zero-state-card__icon" src="assets/images/group-network-zero-state.svg" alt="no-suggestions" />
      <p class="zero-state-card__text">No <span class="discovery-panel__count">suggestions</span> to show</p>
      <button type="button" class="btn primary small" (click)="moveToNextStepEmitter.emit()">Move to Next Step</button>
    </div>
  }
</section>

@if (selectedSuggestions?.length > 0) {
  <div
    class="suggestions-float"
    [class.suggestions-float--offset]="switchFromUser"
    [class.suggestions-float--default]="!switchFromUser"
  >
    <app-shared-floater-action
      [position]="embeddedFloaterPosition"
      [selectedCount]="selectedSuggestions.length"
      [actions]="suggestionsFloaterActions"
      (actionClick)="onFloaterActionClick($event)"
      (closeClick)="onFloaterAction({ action: 'close' })"
    ></app-shared-floater-action>
  </div>
}
